import React from 'react';
import './App.css';
import Header from "./components/common/Header";
import Main from "./components/Main";
import Footer from "./components/common/Footer";

function App() {
  return (
    <div className="App">
      <Header/>
      <Main/>
      <Footer/>
    </div>
  );
}

export default App;
